// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2779":"a51b06d3","6794":"a51b06d3"}[chunkId] + ".chunk.css";
};